import type { ReactEditor } from 'slate-react'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

const DOM_RESOLUTION_ERROR = /Cannot resolve a DOM (point|node) from Slate/

/**
 * Cut and copy go through `setFragmentData`, which resolves the current Slate
 * selection to DOM nodes. When the DOM is stale relative to the Slate model at
 * cut time (e.g. a trailing text node after a link that is not yet committed),
 * slate-react throws while resolving the point. Swallow only that specific
 * failure so the clipboard action becomes a no-op instead of crashing.
 *
 * `setFragmentData` is mixed into the editor at runtime by `withReact`, but
 * isn't part of Plate's own editor type — cast to `ReactEditor` to reach it.
 */
export const withSafeClipboard = (editor: BufferEditor): BufferEditor => {
  const reactEditor = editor as unknown as ReactEditor
  const { setFragmentData } = reactEditor

  reactEditor.setFragmentData = (...args): void => {
    try {
      return setFragmentData(...args)
    } catch (error) {
      if (error instanceof Error && DOM_RESOLUTION_ERROR.test(error.message)) {
        return undefined
      }
      throw error
    }
  }

  return editor
}
